import React from "react";

import { ITypeaheadProps, Typeahead } from "@/components/Typeahead";
import { IFetchKeywordsSearchHistory, IKeyword } from "@/data/keywords";
import { IFetchLocationsHintsSearch, ILocation } from "@/data/locations";
import { typeaheadFactory } from "@/eworkitComponents";

const TypeaheadKeyword: React.FC<ITypeaheadProps<ILocation> & IFetchLocationsHintsSearch> = React.memo(
  ({ ...restProps }) => {
    return <Typeahead {...restProps} />;
  },
);

const fetchKeywordSearchHistoryProxy = async () => {
  return [];
};

export const TypeaheadKeywordHints = typeaheadFactory<ITypeaheadProps, IKeyword, IFetchKeywordsSearchHistory>(
  fetchKeywordSearchHistoryProxy,
  TypeaheadKeyword,
);
